import React from "react";

import svg from "../../assets/images/icons/expand_gray.svg";

export const ExpandGrayIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Expand"}
    />
);
